import React, { useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { PATHS } from 'src/common/constants';
import { selectPropertyById } from 'src/store/selectors/properties';
import { selectServiceRequestFormData } from 'src/store/selectors/serviceRequestForm';
import { exitServiceRequestForm } from 'src/store/actions/serviceRequestForm';
import { selectSuiteById } from 'src/store/selectors/suites';
import Col from '../Col';
import Form from '../Form';
import Row from '../Row';
import Button from '../Button';
import { variables } from 'src/Tenants';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import { BrandingContext } from 'src/branding/BrandingContextProvider';
import './ServiceRequestFormReview.scss';

const ServiceRequestFormReview = () => {
  const dispatch = useDispatch();
  const { branding } = useContext(BrandingContext);

  const serviceRequestFormData: any = useSelector(selectServiceRequestFormData);
  const property: any = useSelector((state) =>
    selectPropertyById(state, serviceRequestFormData.property_id)
  );
  const suite: any = useSelector((state) =>
    selectSuiteById(state, serviceRequestFormData.suite_id)
  );
  const user: any = useSelector(selectAuthenticatedUser);

  const viewServiceRequest = () => {
    try {
      window.history.replaceState(
        {},
        null,
        '/app/service-requests/' + localStorage.getItem('serviceRequestId')
      );
      localStorage.removeItem('ticketId');
      localStorage.removeItem('serviceRequestId');
      window.location.reload();
    } catch (error) {
      console.error(
        `Unexpected error encountered in the Service Request Form Review: ${error}`
      );
    }
  };

  let theme: string = localStorage.getItem('theme');

  return (
    <Form
      onExit={() => {
        dispatch(exitServiceRequestForm());
      }}
      component={
        <Row mdCenter>
          <Col xs="12" md="6">
            <div className="serviceRequestFormReview__image">
              <img
                src="/assets/service-request-review.svg"
                alt="Review service request"
                style={{ display: 'block', margin: 'auto' }}
              />
            </div>
            <div className="serviceRequestFormReview__headline">
              {branding.text.serviceRequestConfirmationHeader}
            </div>
            {theme === 'Oviedo' ? (
              <div className="serviceRequestFormReview__strapline">
                Thank you for submitting a service request. We respond to all
                inquiries in the order they are received and will do our best to
                resolve any concerns you may have.
                <br />
                Please allow up to 7 business days for a reply. <br />
                <br />
                For any emergencies or urgent matters, please follow the
                instructions noted in your homeowner manuals.
              </div>
            ) : theme === 'Shape' ? (
              <div className="serviceRequestFormReview__strapline">
                Thank you for submitting a service request. We respond to all
                inquiries in the order they are received and will do our best to
                resolve any concerns you may have.
                <br />
                Please allow up to 30 business days for a reply. <br />
                <br />
                For any emergencies or urgent matters, please follow the
                instructions noted in your homeowner manuals.
              </div>
            ) : (
              <div className="serviceRequestFormReview__strapline">
                {branding.text.serviceRequestConfirmationBody}
              </div>
            )}
            <div className="serviceRequestFormReview__heading">
              Your {variables.serviceRequest} ticket number is
              <div className="serviceRequestFormReview__number">
                {localStorage.getItem('ticketNumber')
                  ? localStorage.getItem('ticketNumber')
                  : localStorage.getItem('ticketId')}
              </div>
            </div>
            <table className="serviceRequestFormReview__table">
              <tbody>
                <tr>
                  <td className="serviceRequestFormReview__label">
                    Issue Type / Asset
                  </td>
                  <td className="serviceRequestFormReview__value">
                    {serviceRequestFormData.issueType} /{' '}
                    {serviceRequestFormData.asset_item_nameDescription}
                  </td>
                </tr>
                <tr>
                  <td className="serviceRequestFormReview__label">
                    Make / Model
                  </td>
                  <td className="serviceRequestFormReview__value">
                    {serviceRequestFormData.asset_item_make
                      ? serviceRequestFormData.asset_item_make
                      : '—'}{' '}
                    /{' '}
                    {serviceRequestFormData.asset_item_model
                      ? serviceRequestFormData.asset_item_model
                      : '—'}
                  </td>
                </tr>
                <tr>
                  <td className="serviceRequestFormReview__label">
                    {variables.Suite} / Property
                  </td>
                  <td className="serviceRequestFormReview__value">
                    {serviceRequestFormData.IsServiceRequest &&
                    serviceRequestFormData.IsServiceRequest === 'CommonArea'
                      ? property.name
                      : suite.number + ' / ' + property.name}
                  </td>
                </tr>
              </tbody>
            </table>
          </Col>
        </Row>
      }
      footer={
        <div
          style={{
            position: 'fixed',
            bottom: '0',
            left: '0',
            width: '100%',
            background: '#fff',
            padding: '15px',
            boxShadow: '0 0 0.3rem rgba(0, 0, 0, 0.3)',
          }}
        >
          {user.roles[0].role.name === 'Admin' ||
          user.roles[0].role.name === 'Super Admin' ||
          user.roles[0].role.name === 'Property Developer' ? (
            <Button
              color="teal"
              label={`View ${variables.serviceRequest}`}
              size="small"
              onClick={viewServiceRequest}
              block={undefined}
              disabled={undefined}
              outlined={undefined}
              icon={undefined}
              outline={undefined}
              weight={undefined}
              children={undefined}
              style={undefined}
            />
          ) : (
            <Button
              color="teal"
              size="small"
              label={
                <Link
                  style={{ color: 'white' }}
                  to={PATHS.SERVICE_REQUESTS_VIEW.replace(
                    ':id',
                    localStorage.getItem('serviceRequestId')
                  )}
                  onClick={() => {
                    localStorage.removeItem('ticketId');
                    localStorage.removeItem('serviceRequestId');
                    dispatch(exitServiceRequestForm());
                  }}
                >
                  View {variables.serviceRequest}
                </Link>
              }
              block={undefined}
              disabled={undefined}
              outlined={undefined}
              icon={undefined}
              onClick={undefined}
              outline={undefined}
              weight={undefined}
              children={undefined}
              style={undefined}
            />
          )}
        </div>
      }
      actions={undefined}
      headline={undefined}
      onClose={undefined}
      onSubmit={undefined}
      strapline={undefined}
    />
  );
};

export default ServiceRequestFormReview;
